const e=async(e,t,n)=>{let{data:r}=await e.get(`/apps/${t}/orgs/search`,{params:n});return r};export{e as searchAppOrgs};
//# sourceMappingURL=search-app-orgs.mjs.map